module.exports = __webpack_public_path__ + "static/media/daxBot_marker.5da20d18.png";